import { Container, makeStyles } from "@material-ui/core";
import { ShaDowBox } from "../../../components/boxes/ShadowBox";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: `${theme.spacing(4.5)}px ${theme.spacing(5)}px`,
    width: (props) => props.width,
  },
}));

export const Box = ({ children, maxWidth, width }) => {
  const classes = useStyles({ width });

  return (
    <ShaDowBox>
      <Container maxWidth={maxWidth || "sm"} className={classes.root}>
        {children}
      </Container>
    </ShaDowBox>
  );
};
